import type { MuhuratResponse, ShubhMuhuratResponse } from "@ishvaram/api-client";
import { apiRequest, edgeRead } from "./_fetch";

export type { MuhuratResponse };
export type { MuhuratTimeSlot, ShubhMuhuratResponse } from "@ishvaram/api-client";

export type MuhuratPurpose =
  "general" | "meditation" | "business" | "career" | "marriage" | "travel";

export async function getMuhurat(
  date?: string,
  place?: string,
  latitude?: number,
  longitude?: number,
  timezone?: string
): Promise<MuhuratResponse> {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (place) params.set("place", place);
  if (latitude !== undefined) params.set("latitude", String(latitude));
  if (longitude !== undefined) params.set("longitude", String(longitude));
  if (timezone) params.set("timezone", timezone);
  const qs = params.toString();
  return apiRequest<MuhuratResponse>(`/muhurat${qs ? `?${qs}` : ""}`);
}

export async function getShubhMuhurat(params: {
  date?: string;
  latitude?: number;
  longitude?: number;
  /** Offset from UTC in hours. India is 5.5. */
  tz_offset?: number;
  timezone?: string;
  purpose?: MuhuratPurpose;
  place?: string;
}): Promise<ShubhMuhuratResponse> {
  const q = new URLSearchParams();
  if (params.date) q.set("date", params.date);
  if (params.latitude !== undefined) q.set("latitude", String(params.latitude));
  if (params.longitude !== undefined) q.set("longitude", String(params.longitude));
  if (params.tz_offset !== undefined) q.set("tz_offset", String(params.tz_offset));
  if (params.timezone) q.set("timezone", params.timezone);
  if (params.purpose) q.set("purpose", params.purpose);
  if (params.place) q.set("place", params.place);
  return edgeRead<ShubhMuhuratResponse>("muhurat/shubh", q.toString());
}
